exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body,html{line-height:1.15em}", "", {"version":3,"sources":["/home/runner/work/peachjar-parent-webapp/peachjar-parent-webapp/src/shared/themes/enlarged.css"],"names":[],"mappings":"AAAA,UAEI,kBAAoB,CACvB","file":"enlarged.css","sourcesContent":["html, body{\n    /* font-size: 18.75px; */\n    line-height: 1.15em;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/shared/themes/enlarged.css
// module id = 3125
// module chunks = 0